import { FC } from 'react';

import { resolveImageSrc } from '../../../api/client';
import { formatMoney } from '../../../shared/functions/formatter';
import { CardTitle, Meta } from '../../../ui';
import { PREVIEW_AMOUNT_CENTS, PreviewState } from './types';

type CustomerPaymentPreviewProps = { state: PreviewState };

/** What the payer will see, drawn from the same renderer as the display. */
const CustomerPaymentPreview: FC<CustomerPaymentPreviewProps> = ({ state }) => (
  <aside className="paymentPreview">
    <CardTitle>Customer preview</CardTitle>
    <Meta>Example for a {formatMoney(PREVIEW_AMOUNT_CENTS)} order</Meta>
    {state.status === 'ready' ? (
      <>
        <span className="paymentPreviewQrWrap">
          <img className="paymentPreviewQr" src={state.url} alt="Example PayNow QR code" />
          {state.preview.style === 'logo' && state.preview.logo_url && (
            <img className="paymentPreviewLogo" src={resolveImageSrc(state.preview.logo_url)} alt="" />
          )}
        </span>
        <span className="paymentPreviewName">{state.preview.name}</span>
        <span className="paymentPreviewProxy">{state.preview.proxy}</span>
      </>
    ) : (
      <span className="paymentPreviewEmpty">{previewPlaceholder(state.status)}</span>
    )}
  </aside>
);

/** The copy for every non-ready state; idle is the moment before the first load. */
function previewPlaceholder(status: PreviewState['status']): string {
  if (status === 'idle') return 'Waiting for settings…';
  if (status === 'unavailable') return 'Not set up yet';
  if (status === 'error') return 'Preview unavailable';
  return 'Updating preview…';
}

export default CustomerPaymentPreview;
